import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as IconCloseLight } from "../../../asserts/imgs/chart/fubon/close_24px_rounded_light.svg";
import common from "../../../asserts/js/common";

export const WAD = (props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [color, setColor] = useState("AA2211");
  const [thickness, setThickness] = useState(2);
  const [style, setStyle] = useState("s");
  const [showTracker, setShowTracker] = useState(true);
  const [height, setHeight] = useState("1");

  const [localChartSetting, setLocalChartSetting] = useState(null)

  useEffect(() => {
    let localSetting = common.getlocalChartStorage();

    if (localSetting)
      setLocalChartSetting(localSetting.WAD_Option)
  }, []);

  useEffect(() => {
    if (localChartSetting) {
      try {
        const WAD = localChartSetting.option
        props.onTAValueChange({
          ta: "WAD",
          name: `${t("chart5.TA.WAD")} (WAD)`,
          option: {
            color: WAD.color,
            thickness: WAD.thickness,
            style: WAD.style,
            showTracker: WAD.showTracker,
            height: WAD.height,
          },
        });
      } catch { }
    }
  }, [localChartSetting]);

  useEffect(() => {
    const WAD = props.localChartSetting.WAD_Option.option;

    setColor(WAD.color);
    setThickness(parseInt(WAD.thickness) || thickness);
    setStyle(WAD.style);
    setShowTracker(WAD.showTracker);
    setHeight(WAD.height);

  }, [props.localChartSetting]);

  useEffect(() => {
    props.onTAValueChange({
      ta: "WAD",
      name: `${t("chart5.TA.WAD")} (WAD)`,
      option: {
        color: color,
        thickness: thickness,
        style: style,
        showTracker: showTracker,
        height: height,
      },
    });
  }, [color, thickness, style, showTracker, height]);

  useEffect(() => {
    setTAColor();
  }, [props.selectedColor]);

  useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  useEffect(() => {
    const WAD = props.localChartSetting.WAD_Option.option;

    setColor(WAD.color);
    setThickness(parseInt(WAD.thickness) || thickness);
    setStyle(WAD.style);
    setShowTracker(WAD.showTracker);
    setHeight(WAD.height);
  }, [props.isReset]);

  const resetALL = () => {
    setColor("AA2211");
    setThickness(2);
    setStyle("s");
    setShowTracker(true);
    setHeight("1");
  };

  const onResetClick = () => {
    const answer = window.confirm(t("chart5.alertMsg"));
    if (answer) {
      setIsOpen(true);
      resetALL();
    } else {
      setIsOpen(true);
    }
  };

  const openOptionBox = (e) => {
    try {
      if (
        e.target.className.replace(" focus-within", "") ===
        "menusubitem msiaction techicalindicator" ||
        e.target.className.replace(" focus-within", "") === "span" ||
        e.target.className.replace(" focus-within", "") === "optboxarrow" ||
        e.target.className.replace(" focus-within", "") === "msiicon"
      ) {
        if (e.target.className.replace(" focus-within", "") !== "b2dbtn") {
          if (isOpen) setIsOpen(false);
          else setIsOpen(true);
        }
      }
    } catch (err) { }
  };

  // id: string
  const removeTA = (id) => {
    props.removeTA(id);
  };

  const onThicknessChange = (e) => {
    setThickness(e.target.value);
  };

  const onStyleChange = (e) => {
    setStyle(e.target.value);
  };

  const onHeightChange = (e) => {
    setHeight(e.target.value);
  };

  const onShowTracker = () => {
    if (showTracker) setShowTracker(false);
    else setShowTracker(true);
  };

  const setTAColor = () => {
    switch (props.source) {
      case "WAD":
        setColor(props.selectedColor);
        break;
    }
  };

  const onColorClick = () => {
    props.onColorClick(color, "WAD", t("chart5.setting"));
  };

  return (
    <div
      className="menusubitem msiaction techicalindicator"
      id="msi-ta"
      onClick={(e) => openOptionBox(e)}
    >
      {/* <div className="msiicon" onClick={() => removeTA("WAD")}></div> */}
      <div className="box-container">
        <span className="span">{t("chart5.TA.WAD")} (WAD)</span>
        <IconCloseLight
          className="close-icon"
          onClick={() => removeTA("WAD")}
        />
      </div>
      <div
        className="optboxarrow"
        style={isOpen ? { transform: "rotate(180deg)" } : {}}
        onClick={(e) => openOptionBox(e)}
      ></div>
      <div
        className="b2dbtn"
        style={isOpen ? { display: "flex" } : {}}
        title="スタイル設定を初期設定に戻す"
        onClick={onResetClick}
      ></div>
      <div className="msi-optbox" style={isOpen ? {} : { display: "none" }}>
        <div className="menusubitem " id="msi-ta-WAD">
          <div className="taparamlbl">{t("chart5.technicalAnalysisLine")}</div>

          <div className="menusubitem stylebox">
            <div className="styleboxlbl">{t("chart5.setting")}</div>
            <button
              id="msi-ta-UI-p0-color0"
              className="colorpicker"
              value={color}
              data-colorpickerdialogtitle="表示設定"
              style={{ backgroundColor: "#" + color }}
              onClick={onColorClick}
            ></button>
            <div className="inputbox">
              <input
                id="msi-ta-UI-p0-thickness"
                type="number"
                step="1"
                min="1"
                max="9"
                value={thickness}
                maxLength={1}
                style={{ width: "30px" }}
                onChange={(e) => onThicknessChange(e)}
              />
            </div>
            <div className="selectbox" onChange={(e) => onStyleChange(e)}>
              <select id="msi-ta-UI-p0-style" value={style}>
                <option value="s">{t("chart5.realLine")}</option>
                <option value="d">{t("chart5.dotLine")}</option>
              </select>
            </div>
            <div className="showtracker">
              <div
                id="msi-ta-UI-p0-showtracker"
                className={
                  showTracker ? "checkboxbutton-selected" : "checkboxbutton"
                }
                onClick={onShowTracker}
              ></div>
              <div className="styleboxlbl">{t("chart5.showValue")}</div>
            </div>
          </div>
        </div>
        <div className="menusubitem" id="msi-ta-UI">
          <div className="flexbox">
            <div className="taparamlbl">{t("chart5.displayScreenSize")}</div>
            <div className="selectbox taparam">
              <select
                id="msi-ta-UI-ps-h"
                defaultValue="1"
                onChange={(e) => onHeightChange(e)}
                value={height}
              >
                <option value="2">{t("chart5.large")}</option>
                <option value="1">{t("chart5.normal")}</option>
                <option value="0">{t("chart5.small")}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
